import { Directive, ElementRef, EventEmitter, inject, NgZone, OnDestroy, output, Output } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[scrollView]',
})
export class ScrollViewDirective implements OnDestroy {
    private el = inject(ElementRef);
    private zone = inject(NgZone);

    public readonly elementVisible = output<boolean>();
    private intersectionObserver!: IntersectionObserver;

    constructor() {
        this.initIntersectionObserver();
        this.el.nativeElement.classList.add('k-scroll-view');
    }

    private initIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries) => this.handleIntersection(entries), { threshold: 0 });

        this.zone.runOutsideAngular(() => {
            this.intersectionObserver.observe(this.el.nativeElement);
        });
    }

    private handleIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.zone.run(() => {
                    this.elementVisible.emit(true);
                });
            }
        });
    }

    ngOnDestroy() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
    }
}
